/* Thread Lab: variant-aware gallery ordering.
   When the colour option changes, reorder the gallery so the selected colour's
   media come first; everything else stays scrollable below (nothing is hidden).
   Server-side first paint is handled in snippets/product-gallery.liquid. */
(function () {
  function reorderGallery(gallery, value) {
    var normalized = (value || '').trim().toLowerCase();
    if (!normalized) return;

    gallery.querySelectorAll('.product-gallery__media-list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('.product-gallery__media'));
      var matching = items.filter(function (el) { return (el.dataset.mediaGroup || '') === normalized; });
      if (!matching.length) return;

      var rest = items.filter(function (el) { return (el.dataset.mediaGroup || '') !== normalized; });
      matching.concat(rest).forEach(function (el) { list.appendChild(el); });

      if (typeof list.scrollTo === 'function') {
        list.scrollTo({ left: 0, top: 0 });
      }
    });

    /* Impact's own variant-change handler re-applies its "hide other groups"
       filter; we run after it, so undo the hiding — we reorder instead. */
    gallery.querySelectorAll('.product-gallery__media-list .product-gallery__media[hidden]').forEach(function (el) {
      el.removeAttribute('hidden');
    });
    gallery.querySelectorAll('page-dots .tap-area[hidden], .product-gallery__thumbnail[hidden]').forEach(function (el) {
      el.removeAttribute('hidden');
    });

    /* On desktop grids, bring the new colour's first image into view if the
       user has scrolled deep into the gallery. */
    if (gallery.getBoundingClientRect().top < -100) {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('product-gallery[data-group-option-position]').forEach(function (gallery) {
      var position = parseInt(gallery.getAttribute('data-group-option-position'), 10);
      if (!position) return;
      reorderGallery(gallery, variant['option' + position]);
    });
  });
})();
